import React from 'react';

const Header = () => {
  return (
    <div className="hero-banner">
      {/* 顶部红底黑字的 FUNKY DOG 招牌 */}
      {/* 具体内容通过CSS背景图片或文字展示 */}
    </div>
  );
};

export default Header;
